import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'la-popover',
  template: `
    <div [ngClass]="{'la_popover_small' : (size === 'sm'), 'la_popover_large' : (size === 'lg'),
                       'la_popover_small_left' : ((size === 'sm') && (placement === 'left')) ,
                       'la_popover_small_right' : ((size === 'sm') && (placement === 'right')) ,
                       'la_popover_small_center' : ((size === 'sm') && (placement === 'center')) ,
                       'la_popover_large_right' : ((size === 'lg') && (placement === 'right')) ,
                       'la_popover_large_left' : ((size === 'lg') && (placement === 'left')) ,
                       'la_popover_large_center' : ((size === 'lg') && (placement === 'center'))}">
      <ng-content></ng-content>
    </div>
  `,
  styles: [`
    .la_popover_large{width:504px}.la_popover_large,.la_popover_small{border-radius:15px;box-shadow:-10px 10px 20px 0 rgba(0,0,0,.07);background-color:#fff;position:relative;top:-30px;z-index:99}.la_popover_small{width:388px}.la_popover_small_left{right:388px}.la_popover_large_left{right:504px}.la_popover_large_right,.la_popover_small_right{left:0}.la_popover_small_center{right:194px}.la_popover_large_center{right:252px}
  `],
  encapsulation: ViewEncapsulation.None
})
export class LaPopoverComponent {
  private _size = 'sm';
  private _placement = 'center';
  @Input()
  set size(size: string) {
    this._size = size;
  }

  get size(): string {
    return this._size;
  }

  @Input()
  set placement(placement: string) {
    this._placement = placement;
  }

  get placement(): string {
    return this._placement;
  }
}
